import { LogTypeEnum } from "../enums/log-enum";

export class LogEntry {
  entryDate: Date = (new Date());
  message: string = ''
  level: LogTypeEnum = LogTypeEnum.DEBUG;
  data?: any;
  logWithDate: boolean = true;
  logWithExtraInfo: boolean = false;

  buildLogString(): string {
    let value = '';

    if (this.logWithDate) {
      value = `${this.entryDate.toLocaleString()} - `;
    }

    value = `${value}[${LogTypeEnum[this.level]}] ${this.message}`

    if (this.logWithExtraInfo && !!this.data) {
      value += ` - ExtraInfo : ${this.formatParams(this.data)}`;
    }

    return value;
  }

  private formatParams(params: any[]): string | undefined {
    let ret: string | undefined;

    if (Array.isArray(params)) {
      ret = params.join(',');

      if (params.some(p => typeof p == 'object')) {
        ret = "";
        for (const item of params) {
          ret += JSON.stringify(item) + ","
        }
      }
    } else if (typeof params == 'object') {
      ret = JSON.stringify(params);
    }

    return ret;
  }

}





